import Link from './Link'
import Claim from './Claim'

const Block = {
    Link,
    Claim
}

export default Block